import { BarcodeSearchResult } from '@epicuro-next/data/lists';
import { createAction, props } from '@ngrx/store';
export const bulkAddInit = createAction('[ProductList][BulkAdd] Init');

export const bulkAddIdsChange = createAction(
  '[ProductList][BulkAdd] Ids change',
  props<{ ids: string[] }>(),
);

export const bulkAddFetch = createAction(
  '[ProductList][BulkAdd] Fetch products',
  props<{ ids: string[] }>(),
);

export const bulkAddFetchSuccess = createAction(
  '[ProductList][BulkAdd] Fetch products success',
  props<{ products: BarcodeSearchResult[] }>(),
);

export const bulkAddFetchFailure = createAction(
  '[ProductList][BulkAdd] Fetch products failure',
);

export const bulkAddItems = createAction('[ProductList][BulkAdd] Add items');

export const bulkAddItemsSuccess = createAction(
  '[ProductList][BulkAdd] Add items success',
  props<{ id: string }>(),
);

export const bulkAddItemsFailure = createAction(
  '[ProductList][BulkAdd] Add items failure',
);
